import { render, staticRenderFns } from "./TextBalanceCard.vue?vue&type=template&id=b00d5d9a&"
import script from "./TextBalanceCard.vue?vue&type=script&lang=js&"
export * from "./TextBalanceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports